/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseLong } from '../models/api-response-long';
import { ApiResponseOrder } from '../models/api-response-order';
import { ApiResponsePagedResultOrder } from '../models/api-response-paged-result-order';
import { ApiResponseVoid } from '../models/api-response-void';
import { createOrder } from '../fn/order-api/create-order';
import { CreateOrder$Params } from '../fn/order-api/create-order';
import { deleteOrder } from '../fn/order-api/delete-order';
import { DeleteOrder$Params } from '../fn/order-api/delete-order';
import { getCount } from '../fn/order-api/get-count';
import { GetCount$Params } from '../fn/order-api/get-count';
import { getOrder } from '../fn/order-api/get-order';
import { GetOrder$Params } from '../fn/order-api/get-order';
import { getOrderByRef1 } from '../fn/order-api/get-order-by-ref-1';
import { GetOrderByRef1$Params } from '../fn/order-api/get-order-by-ref-1';
import { patchOrderPaymentStatus } from '../fn/order-api/patch-order-payment-status';
import { PatchOrderPaymentStatus$Params } from '../fn/order-api/patch-order-payment-status';
import { patchOrderStatus } from '../fn/order-api/patch-order-status';
import { PatchOrderStatus$Params } from '../fn/order-api/patch-order-status';
import { retryExternalExport } from '../fn/order-api/retry-external-export';
import { RetryExternalExport$Params } from '../fn/order-api/retry-external-export';
import { searchOrders } from '../fn/order-api/search-orders';
import { SearchOrders$Params } from '../fn/order-api/search-orders';
import { updateOrder } from '../fn/order-api/update-order';
import { UpdateOrder$Params } from '../fn/order-api/update-order';
import { updateOrderSalePoint } from '../fn/order-api/update-order-sale-point';
import { UpdateOrderSalePoint$Params } from '../fn/order-api/update-order-sale-point';

@Injectable({ providedIn: 'root' })
export class OrderApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `retryExternalExport()` */
  static readonly RetryExternalExportPath = '/v1/api/orders/{ref}/retry-external-export';

  /**
   * Retry Abeldi export using stored order lines without repricing or payment replay.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retryExternalExport()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryExternalExport$Response(params: RetryExternalExport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
    return retryExternalExport(this.http, this.rootUrl, params, context);
  }

  /**
   * Retry Abeldi export using stored order lines without repricing or payment replay.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retryExternalExport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryExternalExport(params: RetryExternalExport$Params, context?: HttpContext): Observable<ApiResponseOrder> {
    return this.retryExternalExport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrder>): ApiResponseOrder => r.body)
    );
  }

  /** Path part for operation `getOrderByRef1()` */
  static readonly GetOrderByRef1Path = '/v1/api/orders/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderByRef1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderByRef1$Response(params: GetOrderByRef1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
    return getOrderByRef1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrderByRef1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderByRef1(params: GetOrderByRef1$Params, context?: HttpContext): Observable<ApiResponseOrder> {
    return this.getOrderByRef1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrder>): ApiResponseOrder => r.body)
    );
  }

  /** Path part for operation `updateOrder()` */
  static readonly UpdateOrderPath = '/v1/api/orders/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrder$Response(params: UpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
    return updateOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrder(params: UpdateOrder$Params, context?: HttpContext): Observable<ApiResponseOrder> {
    return this.updateOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrder>): ApiResponseOrder => r.body)
    );
  }

  /** Path part for operation `deleteOrder()` */
  static readonly DeleteOrderPath = '/v1/api/orders/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrder$Response(params: DeleteOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrder(params: DeleteOrder$Params, context?: HttpContext): Observable<void> {
    return this.deleteOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createOrder()` */
  static readonly CreateOrderPath = '/v1/api/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrder$Response(params: CreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
    return createOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrder(params: CreateOrder$Params, context?: HttpContext): Observable<ApiResponseOrder> {
    return this.createOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrder>): ApiResponseOrder => r.body)
    );
  }

  /** Path part for operation `searchOrders()` */
  static readonly SearchOrdersPath = '/v1/api/orders/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchOrders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchOrders$Response(params: SearchOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultOrder>> {
    return searchOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchOrders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchOrders(params: SearchOrders$Params, context?: HttpContext): Observable<ApiResponsePagedResultOrder> {
    return this.searchOrders$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultOrder>): ApiResponsePagedResultOrder => r.body)
    );
  }

  /** Path part for operation `getOrder()` */
  static readonly GetOrderPath = '/v1/api/orders/order-effectue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrder$Response(params: GetOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultOrder>> {
    return getOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getOrder(params: GetOrder$Params, context?: HttpContext): Observable<ApiResponsePagedResultOrder> {
    return this.getOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultOrder>): ApiResponsePagedResultOrder => r.body)
    );
  }

  /** Path part for operation `getCount()` */
  static readonly GetCountPath = '/v1/api/orders/order-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCount$Response(params: GetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return getCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCount(params: GetCount$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.getCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

  /** Path part for operation `patchOrderStatus()` */
  static readonly PatchOrderStatusPath = '/v1/api/orders/status/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchOrderStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchOrderStatus$Response(params: PatchOrderStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchOrderStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchOrderStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchOrderStatus(params: PatchOrderStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchOrderStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchOrderPaymentStatus()` */
  static readonly PatchOrderPaymentStatusPath = '/v1/api/orders/payment-status/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchOrderPaymentStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchOrderPaymentStatus$Response(params: PatchOrderPaymentStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return patchOrderPaymentStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchOrderPaymentStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchOrderPaymentStatus(params: PatchOrderPaymentStatus$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.patchOrderPaymentStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `updateOrderSalePoint()` */
  static readonly UpdateOrderSalePointPath = '/v1/api/orders/{reference}/sale-point';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrderSalePoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrderSalePoint$Response(params: UpdateOrderSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
    return updateOrderSalePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrderSalePoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrderSalePoint(params: UpdateOrderSalePoint$Params, context?: HttpContext): Observable<ApiResponseOrder> {
    return this.updateOrderSalePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrder>): ApiResponseOrder => r.body)
    );
  }

}
